import {Link} from "react-router-dom";
import {InfoOutlined} from "@ant-design/icons";
import React, {FunctionComponent} from "react";
import {IsFeatureEnabledOrNot} from "../../../FeatureToggles/FeatureEnabledOrNot";
import {ToggleList} from "../../../FeatureToggles/toggleList";
import "./index.scss";

type Props = {
  linkText: string;
  isVisible: boolean;
  processDocumentActiveTab?: string;
}

export const UserGuideLink: FunctionComponent<Props> = (props: Props) => {
  const isUserGuideFeatureEnabled = IsFeatureEnabledOrNot(ToggleList.UserGuide);

  if (isUserGuideFeatureEnabled && props.isVisible) {
    return (
      <Link
        to={{
          pathname: "/user-guide",
          state: {processDocumentActiveTab: props.processDocumentActiveTab || "business-teams"}
        }}
        className={"user-guide-link"}
      >
        <InfoOutlined style={{margin: "0 4px"}}/>
        {props.linkText}
      </Link>
    )
  }
  return null;
};
